module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jXqtL"))).then(() => parcelRequire('1iHdE'));